import { RoundedButton } from '@components/Buttons/rounded';
import { Col } from '@components/Layout/Col';
import { Row } from '@components/Layout/Row';
import { SummaryContext } from '@components/SummarySelection/context';
import STYLE from '@components/SummarySelection/style';
import { SummaryPreview } from '@components/SummarySelection/SummaryPreview';
import { Trans } from '@components/Trans';
import { useToggle } from '@hooks/useToggle';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import { dispatchWindowEvent } from '@packages/events/lib/dispatchEvent';
import { createMemo } from '@packages/react';
import { orderBy } from 'lodash';
import React, { forwardRef, useCallback, useContext, useEffect } from 'react';
import styled from 'styled-components';

export const SummaryBar = createMemo(
    forwardRef((_, ref) => {
        const [state] = useContext(SummaryContext);
        const collapsed = useToggle(true, 'up', 'down');

        const handleResize = useCallback(() => {
            dispatchWindowEvent('resize');
        }, ['']);

        useEffect(() => () => {
            setTimeout(handleResize);
        });

        const selectionArray = (state.get('skus') || []).map(({ name }) => name);
        const selections = orderBy(selectionArray, (name) => name, 'asc');

        if (state.get('package')) {
            selections.unshift(state.getIn(['package', 'name']));
        }

        let selectionString: string;

        if (selections.length > 3) {
            selectionString = `${selections.slice(0, 3).join(', ')} ... and ${selections.length - 3} more`;
        } else {
            selectionString = selections.join(', ');
        }

        return (
            <Root component={'section'} ref={ref}>
                <Row component={'header'} style={STYLE.summaryBar.header} align={'center'}>
                    <HeaderText xs={12} sm={9} align={'center'}>
                        <Typography variant={'body1'} style={{ marginRight: 4 }}>
                            Selections Summary:
                        </Typography>
                        <Typography variant={'body2'} title={selectionString}>
                            {selectionString}
                        </Typography>
                    </HeaderText>

                    <Col xs={12} sm={3} align={'center'} justify={'end'}>
                        <RoundedButton
                            style={STYLE.summaryBar.expandButton}
                            color={'primary'}
                            onClick={collapsed.handleToggle}
                        >
                            <Trans>{collapsed.state ? 'Expand' : 'Collapse'}</Trans>
                            <Icon>{`keyboard_arrow_${collapsed.current}`}</Icon>
                        </RoundedButton>
                    </Col>
                </Row>

                <Collapse
                    in={!collapsed.state}
                    onExited={handleResize}
                    onEntered={handleResize}
                    style={{ maxWidth: '100%' }}
                >
                    <SummaryPreview />
                </Collapse>
            </Root>
        );
    }),
    { displayName: 'SummaryBar' },
);

const Root = styled(Row)`
    & {
        background-color: rgba(255, 255, 255, 0.8);
        backdrop-filter: saturate(200%) blur(20px);
        border-top: 1px solid #ccc;
    }
`;

const HeaderText = styled(Col)`
    .MuiTypography-root {
        color: #222;
    }
`;
